import ToggleLink from './components/toggleLink/toggleLink';
import Carousel from 'flickity';
import Megadrop from './components/megadrop/megadrop';
import MobileMenu from './components/mobileMenu/mobileMenu';
import FaqFormPopUp from './components/faqFormPopUp/faqFormPopUp';
import TabUsability from './components/tabUsability/tabUsability';
import EpiserverForm from './components/episerverForm/episerverForm';
import { wrap } from './components/utilities/utilities';
import { setCookie, getCookie } from './components/cookie/cookie';
/**
 * App
 * This starting point for this application.
 * @version 3.0.0
 * @exports App
 */
export default class App {
	constructor() {
		// Init menu
		new Megadrop();

		// Init mobile menu
		new MobileMenu();

		// Init faq form
		new FaqFormPopUp();

		// Init toggle link
		new ToggleLink();

		// Init tabUsability
		new TabUsability();

		// Init table wrap for mobile scrolling of tables in rte.
		this._initRteTableWrap();

		// Init ajaxForm
		this._initAjaxForm();

		// Init episerverForms
		this._initEpiserverForm();

		// Demo plugins (for demo purpose only, remove this when you build a new web).
		this._loadPluginsDemonstration();

		this._initCookies();

		this._initDropdowns();

		this._initClearInputFieldButton();

		this._initCarousel();
	}

	/**
	 * Function that initiates the ajax-form functionality.
	 * @private
	 */
	_initAjaxForm() {
		let els = document.querySelectorAll('[data-type="ajaxForm"]');

		if (els.length > 0) {
			import(
				/* webpackChunkName: "ajaxForm" */ './components/ajaxForm/ajaxForm'
			).then(AjaxForm => {
				for (let i = 0; i < els.length; i++) {
					let el = els[i];

					if (el.getAttribute('data-ajaxform-initiated') === null) {
						new AjaxForm.default(el);
						el.setAttribute('data-ajaxform-initiated', true);
					}
				}
			});
		}
	}

	/**
	 * Function that initiates the episerverform functionality.
	 * @private
	 */
	_initEpiserverForm() {
		let els = document.querySelectorAll('[data-type="episerverForm"]');

		if (els.length > 0) {
			for (let i = 0; i < els.length; i++) {
				let el = els[i];

				if (el.getAttribute('data-episerverform-initiated') === null) {
					new EpiserverForm(el);
					el.setAttribute('data-episerverform-initiated', true);
				}
			}
		}
	}

	/**
	 * Function that wraps all tables in rte with a div to enable the scroll-feature in mobile.
	 * @private
	 */
	_initRteTableWrap() {
		let els = document.querySelectorAll('.rte table');

		els.forEach(el => {
			let wrapper = document.createElement('div');
			wrapper.classList.add('table-scrollable');
			wrap(el, wrapper);
		});
	}

	/**
	 * Loads all plugins in the framework to demonstrate them (this should be removed on "real" webprojects).
	 * @todo Remove this function from "real" projects.
	 * @private
	 */
	_loadPluginsDemonstration() {
		if (document.querySelectorAll('[data-type="share"]').length > 0) {
			import(/* webpackChunkName: "share" */ './components/share/share').then(
				Share => {
					new Share.default();
				}
			);
		}

		if (document.querySelectorAll('[data-type="loadMore"]').length > 0) {
			import(
				/* webpackChunkName: "loadMore" */ './components/loadMore/loadMore'
			).then(LoadMore => {
				new LoadMore.default();
			});
		}

		if (document.querySelectorAll('[data-type="autosubmit"]').length > 0) {
			import(
				/* webpackChunkName: "autoSubmit" */ './components/autoSubmit/autoSubmit'
			).then(AutoSubmit => {
				new AutoSubmit.default();
			});
		}

		if (document.getElementById('autoembed-demo')) {
			import(
				/* webpackChunkName: "autoEmbed" */ './components/autoEmbed/autoEmbed'
			).then(AutoEmbed => {
				const testNode = document.getElementById('autoembed-demo');
				const input = testNode.innerHTML;
				const embed = new AutoEmbed.default();
				const htmlWithEmbeds = embed.parse(input);
				testNode.innerHTML = htmlWithEmbeds;
				embed.renderJsEmbeds();
			});
		}
	}
	/**
	 * Initates cookies and cookiebar
	 * @private
	 */
	_initCookies() {
		const cookiebar = document.querySelector('.cookiebar');
		const overlay = document.querySelector('.cookie-overlay');

		if (cookiebar) {
			if (!getCookie('acceptCookieLjungbybostader')) {
				cookiebar.classList.remove('cookiebar--hidden');

				let acceptCookie = cookiebar.querySelectorAll('.cookiebar__accept');

				acceptCookie.forEach(accept => {
					accept.addEventListener('click', e => {
						e.preventDefault();
						setCookie('acceptCookieLjungbybostader', true, 10950, '/');
						cookiebar.classList.add('cookiebar--hidden');
						overlay.classList.remove('cookie-overlay');
					});
				});
			} else {
				overlay.classList.remove('cookie-overlay');
			}
		}
	}
	/**
	 * This function applies the toggle functionallity on the language menus.
	 * @private
	 */
	_initDropdowns() {
		const initToggle = (toggleElement, contentDiv) => {
			let toggle = document.getElementById(toggleElement);
			if (toggle) {
				let usabillityElement = toggle.querySelector(
					'.usability--visuallyhidden'
				);
				let content = document.getElementById(contentDiv);

				toggle.addEventListener('click', () => {
					if (toggle.getAttribute('aria-expanded') === 'true') {
						content.style.display = 'none';
						toggle.setAttribute('aria-expanded', 'false');
						usabillityElement.innerHTML = 'Expandera språkmeny';
					} else {
						content.style.display = 'block';
						toggle.setAttribute('aria-expanded', 'true');
						usabillityElement.innerHTML = 'Dölj språkmeny';
					}
				});
			}
		};

		initToggle('language-toggle-in-the-mobile', 'language-list-in-the-mobile');
		initToggle('language-toggle-in-the-header', 'language-list-in-the-header');
		initToggle('language-toggle-in-the-footer', 'language-list-in-the-footer');
	}
	_initClearInputFieldButton() {
		let inputField = document.getElementsByClassName(
			'search-form__input-field'
		)[0];
		let clearBtn = document.getElementsByClassName('search-form__clear-btn')[0];

		if (inputField && clearBtn) {
			inputField.addEventListener('input', () => {
				if (inputField.value) {
					clearBtn.style.display = 'block';
				} else {
					clearBtn.style.display = 'none';
				}
			});

			clearBtn.addEventListener('click', e => {
				inputField.style.outline = 'none';
				clearInputField(e);
			});

			clearBtn.addEventListener('keydown', e => {
				let usingScreenReader = e.keyCode === 13 || e.keyCode === 32;

				if (usingScreenReader) {
					clearInputField(e);
				}
			});

			const clearInputField = e => {
				e.preventDefault();
				inputField.value = '';
				clearBtn.style.display = 'none';
				inputField.focus();
			};
		}
	}
	_initCarousel() {
		this.body = document.getElementsByTagName('BODY')[0];
		document.addEventListener('DOMContentLoaded', function() {
			if (this.body.classList.contains('.carousel-block')) {
				new Carousel('.carousel-block', {
					// options
					fullscreen: true,
					accessibility: true,
					ImagesLoaded: true,
					// enable keyboard navigation, pressing left & right keys

					adaptiveHeight: false,
					// set carousel height to the selected slide

					autoPlay: false,
					// advances to the next cell
					// if true, default is 3 seconds
					// or set time between advances in milliseconds
					// i.e. `autoPlay: 1000` will advance every 1 second

					pageDots: true,
					// create and enable page dots

					resize: false,
					// listens to window resize events to adjust size & positions
					cellAlign: 'left',
					contain: true,
				});
			}
		});
	}
}
